import { createFormAction } from 'redux-form-saga';
import { FAILURE, REQUEST, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_BROKER_COLOR_SCHEMA = createRequestTypes('GET_BROKER_COLOR_SCHEMA');
export const getBrokerColorSchema = {
  request: brand => action(GET_BROKER_COLOR_SCHEMA[REQUEST], { brand }),
  success: schema => action(GET_BROKER_COLOR_SCHEMA[SUCCESS], { schema }),
  failure: error => action(GET_BROKER_COLOR_SCHEMA[FAILURE], { error }),
};

export const GET_CUSTOMIZATION_BRANDS = createRequestTypes('GET_CUSTOMIZATION_BRANDS');
export const getCustomizationBrands = {
  request: () => action(GET_CUSTOMIZATION_BRANDS[REQUEST]),
  success: brands => action(GET_CUSTOMIZATION_BRANDS[SUCCESS], { brands }),
  failure: error => action(GET_CUSTOMIZATION_BRANDS[FAILURE], { error }),
};

export const updateBrokerColorSchema = createFormAction('UPDATE_BROKER_COLOR_Schema');
